module.exports = __webpack_public_path__ + "static/img/goal-11.18e6d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/goal-11.png
// module id = ItMo
// module chunks = 2